import { Select } from 'antd';

import { styled } from '@mui/material';

export const SelectStyled = styled(Select)`
  height: 40px;
  width: 100%;
  &:hover {
    .ant-select-selector {
      border-color: ${({ theme }) => theme.vars.palette.primary.main} !important;
    }
  }
  &.ant-select-focused {
    .ant-select-selector {
      border-color: ${({ theme }) => theme.vars.palette.primary.main};
    }
  }
`;
